import { createContext, useContext, useEffect, useState } from "react";
import Map from "./map";

interface AppProps {
  encodedMarkers?: string;
  className?: string;
  translations?: string;
}
export interface IMarker {
  id: string;
  url: string;
  title: string;
  email: string;
  phone: string;
  coordinates: number[];
  date: string;
  location: {
    address: string;
    number: string;
    city: string;
  };
  tag?: string;
}

type Translation = { [key: string]: string };
const TranslationContext = createContext<Translation | null>(null);

export function App({
  encodedMarkers,
  className = "",
  translations,
}: AppProps) {
  const [markers, setMarkers] = useState<IMarker[]>([]);
  const [parsedTranslations, setParsedTranslations] =
    useState<Translation | null>(null);

  useEffect(() => {
    if (encodedMarkers) {
      try {
        const markers = JSON.parse(encodedMarkers) as IMarker[];
        if (markers) {
          setMarkers(markers);
        }
      } catch (error) {
        console.error("Invalid:", error);
      }
    }
  }, [encodedMarkers]);

  useEffect(() => {
    if (translations) {
      try {
        setParsedTranslations(JSON.parse(translations));
      } catch (error) {
        console.error("Invalid translations JSON:", error);
      }
    }
  }, [translations]);

  return (
    <TranslationContext.Provider value={parsedTranslations}>
      <Map
        markers={markers}
        showOthers={markers.length !== 1}
        className={className}
      />
    </TranslationContext.Provider>
  );
}

export function useTranslation() {
  const translations = useContext(TranslationContext);
  return (key: string) => (translations ? translations[key] || key : key);
}
